
import API from '@/api'

const actions = {
  getTransfers({ commit, state }, { transferIndex, form }) {
    API.transfers.getCollection(form)
      .then(({ data: { data: { results, searchId } } }) => {
        if (state.transfers[transferIndex].transfers.hasError) {
          commit('setServiceModuleErrors', {
            target: `transfers.${transferIndex}.transfers`,
            status: false,
            errors: []
          })
        }

        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `transfers.${transferIndex}.transfers`
        })

        if (results.length === 0) {
          commit('setServiceModuleErrors', {
            target: `transfers.${transferIndex}.transfers`,
            status: true,
            errors: ['По вашему запросу ничего не найдено, измените параметры поиска.']
          })
        } else {
          commit('setTransfers', {
            transferIndex,
            searchId,
            results
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `transfers.${transferIndex}.transfers`
        })

        commit('setServiceModuleErrors', {
          target: `transfers.${transferIndex}.transfers`,
          status: true,
          errors
        })
      })
  },
  getCityLocations({ commit }, { placeId, direction, transferIndex }) {
    API.transfers.geTransferstLocations({ placeId })
      .then(({ data: { data: { results } } }) => {
        commit('setCitiesLocations', {
          collection: results,
          direction,
          transferIndex
        })
      })
      .catch(({ data: { errors } }) => {})
  },
}

export default actions